import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import SelectAirtableCsv from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-airtable-csv';
import SelectAzureCsv from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-azure-csv';
import SelectGenericCsv from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-generic-csv';
import SelectGithubCsv from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-github-csv';
import SelectGitlabCsv from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-gitlab-csv';
import SelectJetbrainsCsv from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-jetbrains-csv';
import SelectLinearCsv from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-linear-csv';
import SelectNotionCsv from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-notion-csv';
import SelectSmartsheetCsv from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-smartsheet-csv';
import SelectWrikeCsv from '@atlassian/jira-illustrations/src/ui/adg4/jira/other/components/select-wrike-csv';
import {
	CSV,
	GITHUB,
	GITLAB,
	AIRTABLE,
	WRIKE,
	NOTION,
	JETBRAINS_YOUTRACK,
	SMART_SHEET,
	LINEAR,
	AZURE_DEVOPS,
	type ImportType,
} from '../../../common/constants/import-type';

export const CsvIllustration = ({ importType }: { importType?: ImportType }) => (
	<Box xcss={containerStyles}>{CsvIllustrations(importType)}</Box>
);

export const CsvIllustrations = (importType?: ImportType) => {
	switch (importType) {
		case CSV:
			return (
				<SelectGenericCsv
					alt="select generic csv"
					data-testid="project-create-importer-upload-flow.ui.upload-screen-standard.illustration.csv"
				/>
			);
		case GITHUB:
			return (
				<SelectGithubCsv
					alt="select github csv"
					data-testid="project-create-importer-upload-flow.ui.upload-screen-standard.illustration.github"
				/>
			);
		case GITLAB:
			return (
				<SelectGitlabCsv
					alt="select gitlab csv"
					data-testid="project-create-importer-upload-flow.ui.upload-screen-standard.illustration.gitlab"
				/>
			);
		case AIRTABLE:
			return (
				<SelectAirtableCsv
					alt="select jira airtable csv"
					data-testid="project-create-importer-upload-flow.ui.upload-screen-standard.illustration.airtable"
				/>
			);
		case WRIKE:
			return (
				<SelectWrikeCsv
					alt="select wrike csv"
					data-testid="project-create-importer-upload-flow.ui.upload-screen-standard.illustration.wrike"
				/>
			);
		case NOTION:
			return (
				<SelectNotionCsv
					alt="select notion csv"
					data-testid="project-create-importer-upload-flow.ui.upload-screen-standard.illustration.notion"
				/>
			);
		case JETBRAINS_YOUTRACK:
			return (
				<SelectJetbrainsCsv
					alt="select jetbrains csv"
					data-testid="project-create-importer-upload-flow.ui.upload-screen-standard.illustration.jetbrains-youtrack"
				/>
			);
		case SMART_SHEET:
			return (
				<SelectSmartsheetCsv
					alt="select smartsheet csv"
					data-testid="project-create-importer-upload-flow.ui.upload-screen-standard.illustration.smartsheet"
				/>
			);
		case LINEAR:
			return (
				<SelectLinearCsv
					alt="select linear csv"
					data-testid="project-create-importer-upload-flow.ui.upload-screen-standard.illustration.linear"
				/>
			);
		case AZURE_DEVOPS:
			return (
				<SelectAzureCsv
					alt="select azure csv"
					data-testid="project-create-importer-upload-flow.ui.upload-screen-standard.illustration.devops"
				/>
			);
		default:
			return null;
	}
};

const containerStyles = xcss({
	width: '400px',
});
